<template>
    <div>
        <NavbarStyleTwo />
        <PageTitle pageTitle="IT-Beratung" pageDesc="Die richtige Entscheidung treffen" />
        <ItBeratungDetails />
        <Footer :showDivider="true" />
    </div>
</template>

<script>
import { useHead } from '@vueuse/head';
import NavbarStyleTwo from '../Layouts/NavbarStyleTwo';
import PageTitle from '../Common/PageTitle';
import ItBeratungDetails from '../SingleService/ItBeratungDetails'
import Footer from '../Layouts/Footer'

export default {
    name: 'ItBeratungPage',
    setup() {
        useHead({
            title: 'IT-Beratung Wien - Digitale Strategie | Benovium',
            meta: [
                { name: 'description', content: 'IT-Beratung aus Wien. Unabhängige Beratung bei Technologieentscheidungen, Software-Auswahl und digitaler Transformation für KMUs.' },
                { property: 'og:title', content: 'IT-Beratung Wien - Benovium' },
                { property: 'og:description', content: 'Unabhängige IT-Beratung für Ihr Unternehmen.' },
                { property: 'og:url', content: 'https://benovium.com/services/it-beratung' },
            ],
            link: [
                { rel: 'canonical', href: 'https://benovium.com/services/it-beratung' }
            ]
        });
    },
    components: {
        NavbarStyleTwo,
        PageTitle,
        ItBeratungDetails,
        Footer,
    }
};
</script>
